<template>
  <div>
    <component style="display: none" :is="show_document"></component>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol>
                <strong>فاکتور فروش تامین کننده</strong>
              </CCol>
              <CCol style="text-align: end;">
                <CButton
                    class="mr-1"
                    size="sm"
                    @click="print_with_header('print_report_buy','print_report_header','print_report_footer')"
                    color="secondary"
                >{{ $t("buttons.print") }}
                </CButton>

              </CCol>

            </CRow>

          </CCardHeader>

          <CRow>
            <CCol>{{factor_info.docDate}}</CCol>
            <CCol>{{factor_info.supplierName}}</CCol>
            <CCol>{{factor_info.masterCode}}</CCol>
          </CRow>
          <CRow>
            <CCol>هزینه پیک: {{factor_info.deliveryCost}}</CCol>
            <CCol>{{factor_info.partyName}}</CCol>
            <CCol>{{get_currency(factor_info.totalPrice)}}</CCol>
          </CRow>
          <CRow>
            <CCol v-if="factor_info.deliveryStatus==0">وضعیت: ثبت شده</CCol>
            <CCol v-if="factor_info.deliveryStatus==1">وضعیت: در دست راننده</CCol>
            <CCol v-if="factor_info.deliveryStatus==2">وضعیت: تحویل مشتری</CCol>

          </CRow>

          <CCardBody id="print_report_buy">

            <CDataTable
                :items="factor_info.products"
                :fields="fields"
                column-filter
                @row-clicked="table_row_clicked"
                :items-per-page="20"
                hover
                sorter
                border
                striped
                :sorter-value="{column:'recId',asc:false}"
                pagination
            >
              <template #row="{item,index}">
                <td style="text-align: center">
                  <p>{{ index + 1 }}</p>
                </td>
              </template>
              <template #createdAt="{item}">
                <td>
                  <p>{{ get_date(item.createdAt) }}</p>
                </td>
              </template>

              <template #totalPrice="{item}">
                <td>
                  <p>{{ get_currency(item.unitPrice*item.qty) }}</p>
                </td>
              </template>
              <template #totalPricePurchase="{item}">
                <td>
                  <p>{{ get_currency(item.purchasePrice*item.qty) }}</p>
                </td>
              </template>
              <template #caption>
                <td class="bg-dark">سود</td>
                <td class="bg-dark">{{get_currency(total_item_price()-total_item_price_purchase()+factor_info.deliveryCost)}}</td>
                <td class="bg-dark"></td>
                <td class="bg-dark"></td>
                <td class="bg-dark">جمع کل</td>
                <td class="bg-dark">{{ get_currency(total_item_price_purchase()) }}</td>

                <td class="bg-dark">{{ get_currency(total_item_price()) }}</td>

              </template>
            </CDataTable>
            <label>کالا های برگشتی</label>
            <CCol col="6">
            <CDataTable
                :items="factor_info.productRets"
                :fields="fields_ret"
                column-filter
                @row-clicked="table_row_clicked"
                :items-per-page="20"
                hover
                sorter
                border
                striped
                :sorter-value="{column:'recId',asc:false}"
                pagination
            >
              <template #row="{item,index}">
                <td style="text-align: center">
                  <p>{{ index + 1 }}</p>
                </td>
              </template>
              <template #createdAt="{item}">
                <td>
                  <p>{{ get_date(item.createdAt) }}</p>
                </td>
              </template>


            </CDataTable>
            </CCol>
          </CCardBody>

        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'

var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
var items_data = [];


export default {
  name: 'Login',
  components: {
    Treeselect,
    'test-dynamic': () => import('../documents/PrintDocument'),

  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      show_document: 'test-dynamic',
      printed_doc_id: 0,
      name: '',

      factor_info:{},
      start_date: '',
      end_date: '',
      submit_refer: 0,
      refer_person: null,
      selected_driver: 0,
      driver_items: [],
      items_sell: [],
      table_clicks_timer: '',
      table_clicks: 0,

      fields: [
        {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
        {key: 'productName', label: this.$t('tables.name'), _style: 'width:15%'},

        {key: 'qty', label: this.$t('tables.qty'), _style: 'width:2%'},
        {key: 'purchasePrice', label: "قیمت خرید", _style: 'width:10%'},
        {key: 'unitPrice', label: "قیمت فروش", _style: 'width:10%'},

        {key: 'totalPricePurchase', label: this.$t('tables.totalAmount'), _style: 'width:10%'},
        {key: 'totalPrice', label: this.$t('tables.totalAmount'), _style: 'width:10%'},
      ],
      fields_ret: [
        {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
        {key: 'productName', label: this.$t('tables.name'), _style: 'width:15%'},

        {key: 'qty', label: this.$t('tables.qty'), _style: 'width:2%'},
        // {key: 'purchasePrice', label: "قیمت خرید", _style: 'width:10%'},
        // {key: 'unitPrice', label: "قیمت فروش", _style: 'width:10%'},

        // {key: 'totalPricePurchase', label: this.$t('tables.totalAmount'), _style: 'width:10%'},
        // {key: 'totalPrice', label: this.$t('tables.totalAmount'), _style: 'width:10%'},
      ],

      status_form: 0,

    }
  }, mounted() {

    this.start_date = this.get_day_before_today_in_day(1);
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];
    this.get_all_data();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.person_id': function () {
      this.get_all_data();
    },
    'start_date': function () {
      this.get_all_data();
    },
    'end_date': function () {
      this.get_driver_lists();
    },
    'selected_driver': function () {
      this.get_all_data();

    }
  },
  methods: {
    total_item_price(){
      var total_price = 0;
      this.factor_info.products.forEach((val)=>{
        total_price+=val.unitPrice*val.qty;
      })
      return total_price;
    },
    total_item_price_purchase(){
      var total_price = 0;
      this.factor_info.products.forEach((val)=>{
        total_price+=val.purchasePrice*val.qty;
      })
      return total_price;
    },
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.goShowDocument(item)

      }

    },
    goShowDocument(item) {

      // this.$router.push({path: '/dashboard/direct-sell/show-doc/' + item.id});
    },
    get_all_data() {
      this.get_lists_sell();

    },

    get_lists_sell() {

      var self = this;


      const formData = new FormData();
      var url = "GetSuppFactorInfoById";
      // formData.append("SupplierId", localStorage.getItem('user_id'));
      formData.append("Id", this.$route.params.doc_id);
      axios.post(url, formData, {}).then(function (response) {
        var content_data = response.data;
        if (content_data.statusCode == 0) {
          self.factor_info = content_data.data
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });


    },
    get_driver_lists() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetDistributorUsers', formData, {}).then(function (response) {

        var content_data = response.data;
        self.driver_items = [{label: 'انتخاب کنید', value: 0}]
        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.driver_items = self.sort_array(self.driver_items, content_data.data, 'personId', 'personName');
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },


  },

}

</script>
